export const ENVIRONMENTAL_RISK_SOURCE_ID = "environmental-risk-neighborhoods";
export const ENVIRONMENTAL_RISK_BADGE_LAYER = "environmental-risk-neighborhood-badges";
export const ENVIRONMENTAL_RISK_FLOOD_SOURCE_ID = "environmental-risk-flood-surface";
export const ENVIRONMENTAL_RISK_FLOOD_LAYER = "environmental-risk-flood-surface-fill";

export const RISK_LEVEL_COLORS = {
  low: "#22c55e",
  moderate: "#eab308",
  elevated: "#f97316",
  high: "#ef4444",
  critical: "#7f1d1d",
  unavailable: "#94a3b8",
};

export const RISK_LEVEL_LABELS = {
  low: "Low",
  moderate: "Moderate",
  elevated: "Elevated",
  high: "High",
  critical: "Critical",
  unavailable: "Unavailable",
};

export const RISK_LEVEL_COLOR_EXPRESSION = [
  "match",
  ["get", "riskLevel"],
  "moderate",
  RISK_LEVEL_COLORS.moderate,
  "elevated",
  RISK_LEVEL_COLORS.elevated,
  "high",
  RISK_LEVEL_COLORS.high,
  "critical",
  RISK_LEVEL_COLORS.critical,
  "unavailable",
  RISK_LEVEL_COLORS.unavailable,
  RISK_LEVEL_COLORS.low,
];

export const RISK_LEVEL_LEGEND = [
  { id: "low", label: "Low", color: RISK_LEVEL_COLORS.low },
  { id: "moderate", label: "Moderate", color: RISK_LEVEL_COLORS.moderate },
  { id: "elevated", label: "Elevated", color: RISK_LEVEL_COLORS.elevated },
  { id: "high", label: "High", color: RISK_LEVEL_COLORS.high },
  { id: "critical", label: "Critical", color: RISK_LEVEL_COLORS.critical },
  { id: "unavailable", label: "No data", color: RISK_LEVEL_COLORS.unavailable },
];

export const RISK_DISCLAIMER =
  "Rule-based environmental indicators — not official safety ratings or engineering assessments.";
